export function getGlobalWindow() {
	return window;
}

export const getScreen = () => {
	try {
		const { screen } = getGlobalWindow();
		if (screen) return { width: screen.width, height: screen.height };
		return null;
	} catch (error) {
		return null;
	}
};
